<template>
<section class="request">
  <SectionQuiz
    v-if="quizStat"
  />
  <div class="container">
    <div class="row">
      <div class="text">
        Оставьте заявку и мы поможем вам с проектом
      </div>
      <div class="btm">
        <button class="button button_small" @click="plusQuiz()">
          Оставить заявку
        </button>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import SectionQuiz from "@/components/SectionQuiz";
export default {
  name: 'SectionRequest',
  components: {
    SectionQuiz
  },
  methods: {
    ...mapActions(['plusQuiz']),
    openQuiz () {
      this.plusQuiz()
    }
  },
  computed: {
    ...mapGetters(['quizStat'])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.request {
  background-color: #eee;
  padding: 45px 0;
  @media (max-width: 575.98px) {
    padding: 20px 0;
  }
  .row {
    background-color: #E0E0E0;
    display: flex;
    flex-wrap: wrap;
    padding: 60px 80px;
    justify-content: space-between;
    @media (max-width: 575.98px) {
      padding: 20px 30px;
    }
    .text {
      font-weight: 500;
      font-size: 2rem;
      max-width: 400px;
      @media (max-width: 997.98px) {
        margin-bottom: 20px;
      }
    }
    button {
      @media (max-width: 575.98px) {
        font-size: 1.6rem;
      }
    }
  }
}
</style>
